var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// libs
import { create } from 'zustand';
// constants
import { INITIAL_STATE } from './constants';
import { NULL } from '@/constants/Misc';
import { localStorageKeys } from '@/constants/storage';
// helpers
import { readFromLocalStorage, writeToLocalStorage } from '@/helpers/storage';
const useAccountStore = create((set, get) => (Object.assign(Object.assign({}, structuredClone(INITIAL_STATE)), { setAccounts: (accounts) => set({ accounts }), setLoggedInAccountDetails: (details) => {
        var _a;
        set({ loggedInAccountDetails: details });
        if ((_a = details.account) === null || _a === void 0 ? void 0 : _a.accountId) {
            writeToLocalStorage(localStorageKeys.CURRENT_ACCOUNT_ID, details.account.accountId);
        }
    }, clearLoggedInAccountDetails: () => {
        set({ loggedInAccountDetails: INITIAL_STATE.loggedInAccountDetails });
        writeToLocalStorage(localStorageKeys.CURRENT_ACCOUNT_ID, NULL);
    }, setUser: (user) => set({ user }), getCurrentAccountId: () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            const accountId = (_a = get().loggedInAccountDetails.account) === null || _a === void 0 ? void 0 : _a.accountId;
            if (accountId) {
                return accountId;
            }
            const currentAccountId = yield readFromLocalStorage(localStorageKeys.CURRENT_ACCOUNT_ID);
            return currentAccountId !== null && currentAccountId !== void 0 ? currentAccountId : NULL;
        }
        catch (_b) {
            return NULL;
        }
    }) })));
export default useAccountStore;
